import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from '@ui/dialog.tsx';
import { UpdateTypologyForm } from './update-typology-form.tsx';
import type { TypologyTypologyReadModel } from '@r/api/generated/client.schemas.ts';

type Typology = TypologyTypologyReadModel;

interface UpdateTypologyDialogProps {
  typology: Typology | null;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess: () => void;
}

export const UpdateTypologyDialog: FC<UpdateTypologyDialogProps> = ({
  typology,
  isOpen,
  onOpenChange,
  onSuccess
}) => {
  const { t } = useTranslation();

  const handleSuccess = () => {
    onOpenChange(false);
    onSuccess();
  };

  const handleConfirmSetDefault = (onConfirm: () => void) => {
    onOpenChange(false);
    toast(t('admin.typology.update.default.confirm'), {
      action: {
        label: t('label.confirm'),
        onClick: onConfirm
      },
      cancel: {
        label: t('label.cancel'),
        onClick: () => {}
      }
    });
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="p-10 !rounded-3xl">
        <DialogHeader>
          <DialogTitle className="text-2xl">{t('admin.typology.update.dialog.title')}</DialogTitle>
          <DialogDescription>{t('admin.typology.update.dialog.description')}</DialogDescription>
        </DialogHeader>

        {isOpen && typology && (
          <UpdateTypologyForm
            typology={typology}
            onSuccess={handleSuccess}
            onConfirmSetDefault={handleConfirmSetDefault}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
